// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QuickJournalDuneHeatMirage__container___dY9Gq {
    position: absolute;
    inset: 0;
    overflow: hidden;
    pointer-events: none;
    z-index: 0;
}

.QuickJournalDuneHeatMirage__container___dY9Gq::before {
    content: "";
    position: absolute;
    inset: 0;
    background-image:
        radial-gradient(circle, rgba(255, 198, 118, 0.16) 0 0.45px, transparent 0.8px),
        radial-gradient(circle, rgba(117, 70, 48, 0.18) 0 0.55px, transparent 0.9px);
    background-position: 0 0, 3px 5px;
    background-size: 7px 9px, 11px 13px;
    opacity: 0.13;
}

.QuickJournalDuneHeatMirage__bottomDustSheet___U05fU {
    position: absolute;
    left: -12%;
    right: -12%;
    bottom: -26px;
    height: 34%;
    border-radius: 50% 50% 0 0;
    background:
        radial-gradient(
            ellipse at 20% 72%,
            rgba(255, 178, 96, 0.16) 0%,
            rgba(130, 63, 42, 0.1) 34%,
            rgba(70, 33, 23, 0.055) 58%,
            rgba(70, 33, 23, 0) 82%
        ),
        radial-gradient(
            ellipse at 78% 68%,
            rgba(255, 150, 78, 0.12) 0%,
            rgba(120, 54, 39, 0.085) 36%,
            rgba(60, 28, 21, 0) 78%
        );
    filter: blur(18px);
    opacity: 0.34;
    animation: QuickJournalDuneHeatMirage__quickJournalDuneDustSheet___Zr4Xm 16s ease-in-out infinite;
}

.QuickJournalDuneHeatMirage__dustWisp___YnSzB {
    position: absolute;
    bottom: -28px;
    width: 280px;
    height: 160px;
    border-radius: 50%;
    background:
        radial-gradient(
            ellipse at 50% 62%,
            rgba(255, 187, 111, 0.16) 0%,
            rgba(172, 88, 55, 0.1) 36%,
            rgba(94, 45, 33, 0.05) 62%,
            rgba(94, 45, 33, 0) 82%
        );
    filter: blur(20px);
    opacity: 0;
    animation: QuickJournalDuneHeatMirage__quickJournalDuneDustRise___OxI9j 16s ease-in-out infinite;
}

.QuickJournalDuneHeatMirage__dustLeft___C2WOH {
    left: -2%;
}

.QuickJournalDuneHeatMirage__dustMidLeft___sm9ST {
    left: 22%;
    width: 230px;
    opacity: 0;
    animation-duration: 20s;
    animation-delay: -6s;
}

.QuickJournalDuneHeatMirage__dustRight___beNEn {
    right: 5%;
    width: 300px;
    animation-duration: 22s;
    animation-delay: -9s;
}

.QuickJournalDuneHeatMirage__dustFarRight___rLQsX {
    right: 22%;
    width: 210px;
    opacity: 0;
    animation-duration: 24s;
    animation-delay: -13s;
}

@keyframes QuickJournalDuneHeatMirage__quickJournalDuneDustSheet___Zr4Xm {
    0%,
    100% {
        opacity: 0.34;
        transform: translate3d(-18px, 0, 0) scaleX(0.96);
    }

    45% {
        opacity: 0.6;
        transform: translate3d(18px, -8px, 0) scaleX(1.08);
    }
}

@keyframes QuickJournalDuneHeatMirage__quickJournalDuneDustRise___OxI9j {
    0%,
    100% {
        opacity: 0;
        transform: translate3d(0, 16px, 0) scale(0.74, 0.64);
    }

    32% {
        opacity: 0.24;
        transform: translate3d(10px, -20px, 0) scale(1.06, 0.96);
    }

    66% {
        opacity: 0.16;
        transform: translate3d(-10px, -52px, 0) scale(1.18, 1.12);
    }
}

@media (prefers-reduced-motion: reduce) {
    .QuickJournalDuneHeatMirage__bottomDustSheet___U05fU,
    .QuickJournalDuneHeatMirage__dustWisp___YnSzB {
        animation: none;
    }

    .QuickJournalDuneHeatMirage__dustWisp___YnSzB {
        opacity: 0.12;
        transform: translate3d(0, -12px, 0) scale(0.9, 0.82);
    }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `QuickJournalDuneHeatMirage__container___dY9Gq`,
	"bottomDustSheet": `QuickJournalDuneHeatMirage__bottomDustSheet___U05fU`,
	"quickJournalDuneDustSheet": `QuickJournalDuneHeatMirage__quickJournalDuneDustSheet___Zr4Xm`,
	"dustWisp": `QuickJournalDuneHeatMirage__dustWisp___YnSzB`,
	"quickJournalDuneDustRise": `QuickJournalDuneHeatMirage__quickJournalDuneDustRise___OxI9j`,
	"dustLeft": `QuickJournalDuneHeatMirage__dustLeft___C2WOH`,
	"dustMidLeft": `QuickJournalDuneHeatMirage__dustMidLeft___sm9ST`,
	"dustRight": `QuickJournalDuneHeatMirage__dustRight___beNEn`,
	"dustFarRight": `QuickJournalDuneHeatMirage__dustFarRight___rLQsX`
};
module.exports = ___CSS_LOADER_EXPORT___;
